export const permissions = {
  view_grns: "view_grns",
  manage_grns: "manage_grns",
  view_orders: "view_orders",
  manage_orders: "manage_orders",
  view_vehicles: "view_vehicles",
  manage_vehicles: "manage_vehicles",
  view_reports: "view_reports",
  view_users: "view_users",
  manage_users: "manage_users",
  view_masters: "view_masters",
  view_fleet_master: "view_fleet_master",
  view_fleet_master_actions: "view_fleet_master_actions",
  manage_masters: "manage_masters",
  view_dashboard: "view_dashboard",
  manage_dashboard: "manage_dashboard",
  manage_roles_and_permissions: "manage_roles_and_permissions",
  view_roles_and_permissions: "view_roles_and_permissions",
  manage_retread: "manage_retread",
  view_stencil_menu: "view_stencil_menu",
  manage_stencil_menu: "manage_stencil_menu",
  view_stencil_search: "view_stencil_search",
  manage_stencil_search: "manage_stencil_search",
  view_non_cpkm_tyres: "view_non_cpkm_tyres",
  manage_non_cpkm_tyres: "manage_non_cpkm_tyres",
  view_orders: "view_orders",
  manage_orders: "manage_orders",
  view_inspections: "view_inspections",
  manage_inspections: "manage_inspections",
  view_inspection_report: "view_inspection_report",
  view_inspection_pending_report: "view_inspection_pending_report",
  view_inspection_trend_report: "view_inspection_trend_report",
  view_scrap_analysis_report: "view_scrap_analysis_report",
  view_scraping_casing_dashboard:"view_scraping_casing_dashboard",
  upload_cpkm: "upload_cpkm",
  view_cpkm: "view_cpkm",
  update_cpkm: "update_cpkm",
  delete_cpkm: "delete_cpkm",
  view_cpkm_report: "view_cpkm_report",
  view_month_wise_tyre_trend_report: "view_month_wise_tyre_trend_report",
  view_onwheel_stencil_report: "view_onwheel_stencil_report",
  view_email: "view_email",
  manage_email: "manage_email",
  view_fleet_master:"view_fleet_master",
  view_fleet_master_actions:"view_fleet_master_actions",
  view_igrn_approval_report: "view_igrn_approval_report",
  view_twc_issues: "view_twc_issues",
  view_grn_status_report: "view_grn_status_report",
  view_grn_rejected_report: "view_grn_rejected_report",
  view_fleet_wise_stock_report: "view_fleet_wise_stock_report",
  view_wheel_alignment_report: "view_wheel_alignment_report",
  view_wheel_alignment_summary_report: "view_wheel_alignment_summary_report",
  view_onwheel_stencil_report: "view_onwheel_stencil_report",
  view_vehicle_enrollment_report: "view_vehicle_enrollment_report",
  view_alignment_pending_report: "view_alignment_pending_report",
  view_twc_issues: 'view_twc_issues',
  manage_twc_issues: "manage_twc_issues",  
  view_tyre_validation: "view_tyre_validation",
  manage_tyre_validation: "manage_tyre_validation",
  manage_deenrollment: "manage_deenrollment",
  view_deenrollment: "view_deenrollment",
  stock_transfer: "stock_transfer",
  create_dtp_points: "create_dtp_points",
  edit_dtp_points: "edit_dtp_points",
  delete_dtp_points: "delete_dtp_points",
  view_dtp_points: "view_dtp_points",
  create_training_material: "create_training_material",
  edit_training_material: "edit_training_material",
  delete_training_material: "delete_training_material",
  view_training_material: "view_training_material",
  create_dtp_plan: "create_dtp_plan",
  edit_dtp_plan: 'edit_dtp_plan',
  delete_dtp_plan: "delete_dtp_plan",
  view_dtp_plan: "view_dtp_plan",
  approve_dtp_plan: "approve_dtp_plan",
  create_dtp_points: "create_dtp_points",
  view_dtp_points: "view_dtp_points",
  edit_dtp_points: "edit_dtp_points",
  create_dtp: "create_dtp",
  edit_dtp: "edit_dtp",
  view_dtp: "create_dtp",
  delete_dtp: "delete_dtp",
  send_email_dtp: "send_email_dtp",
  web_app_access: "web_app_access",
  delete_vehicle: "delete_vehicle",
  external_stock_transfer: "external_stock_transfer",
  approve_external_stock_transfer: "approve_external_stock_transfer",
  external_stock_transfer_discount: "external_stock_transfer_discount",
  view_mobility_dashboard: "view_mobility_dashboard",
  view_rotation_pending_report: "view_rotation_pending_report",
  approve_internal_stock_transfer: "approve_internal_stock_transfer",
  daily_tyre_replacement_report:"daily_tyre_replacement_report",
  inspection_kilometer_update: "inspection_kilometer_update",
  view_grn_pending_report: "view_grn_pending_report",
  view_batch_wise_report: "view_batch_wise_report",
  view_actual_cpkm_dashboard: "view_actual_cpkm_dashboard",
  view_agreed_cpkm_dashboard: "view_agreed_cpkm_dashboard",
  view_mechancial_issue_report: "view_mechancial_issue_report",
  view_retread_request: "view_retread_request",
  create_retread_request: "create_retread_request",
  approve_retread_request: "approve_retread_request",
  dispatch_retread_request: "dispatch_retread_request",
  delete_tyre: "delete_tyre",
  view_fleet_inspection_history_report:"view_fleet_inspection_history_report",
  download_inspection_dump: "download_inspection_dump",
};

export default permissions;
